export type ComparisonStatusKind = 'full' | 'partial' | 'none';

export type ComparisonCheckTone = 'brand' | 'neutral';

export type ComparisonCompetitor = 'udacity' | 'chatgptClaude' | 'coursera';

export type ComparisonRowId = 'curriculum' | 'projects' | 'accredited' | 'community';

export type ComparisonStatusPresentation = 'brand-check' | 'neutral-check' | 'partial-text' | 'partial-icon' | 'none';

export const HOMEPAGE_COMPARISON_COMPETITORS: readonly ComparisonCompetitor[] = [
  'udacity',
  'chatgptClaude',
  'coursera',
];

export const HOMEPAGE_COMPARISON_ROWS: readonly {
  id: ComparisonRowId;
  statuses: Record<ComparisonCompetitor, ComparisonStatusKind>;
}[] = [
  {
    id: 'curriculum',
    statuses: {
      udacity: 'full',
      chatgptClaude: 'partial',
      coursera: 'full',
    },
  },
  {
    id: 'projects',
    statuses: {
      udacity: 'full',
      chatgptClaude: 'none',
      coursera: 'partial',
    },
  },
  {
    id: 'accredited',
    statuses: {
      udacity: 'full',
      chatgptClaude: 'none',
      coursera: 'partial',
    },
  },
  {
    id: 'community',
    statuses: {
      udacity: 'full',
      chatgptClaude: 'partial',
      coursera: 'partial',
    },
  },
];

export function getComparisonCheckTone(competitor: ComparisonCompetitor): ComparisonCheckTone {
  return competitor === 'udacity' ? 'brand' : 'neutral';
}
